<template>
  <div class="rootContainer">
    <searchBar class="searchBar" searchType="16" @search="onSearch"></searchBar>

    <div ref="topBarDom" id="top-bar-container">
      <filterMenu
        title="类型"
        displayName="name"
        v-model="fileType"
        :filtersContent="fileTypeFlags"
        @selectChanged="filterChanged"
      ></filterMenu>

      <div>
        <filterMenu
          title="分类"
          displayName="name"
          v-model="category"
          :filtersContent="categorys"
          :openShowMoreBtn="true"
          @selectChanged="filterChanged"
        ></filterMenu>
      </div>

      <div class="fixed-filter-container">
        <div>
          <filterMenu
            title="排序"
            displayName="name"
            v-model="sort"
            :filtersContent="sortFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="价格"
            displayName="name"
            v-model="price"
            :filtersContent="resourceLevelOptions"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="授权"
            displayName="name"
            v-model="commerical"
            :filtersContent="commericalFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <styleMenu
          class="style-layout"
          v-model="currentStyle"
          :menuList="StyleArrayMsg"
          @selectChange="onStyleChange"
        ></styleMenu>
      </div>
    </div>
    <div
      class="content-container"
      ref="contentcontainer"
      @scroll="handleScroll"
    >
      <ul class="content-list">
        <li v-for="(item, index) in contentList" :key="index">
          <div @click="addToCanvas(item)" class="bg">
            <img
              class="static-cover"
              :src="$handleAssetsUrl(item.thumbnailUrl)"
              alt
            />
            <div class="logo-container">
              <div v-show="item.isCommerical" class="commerical-logo"></div>
            </div>

            <!-- <div class="addbtn" @click="addToCanvas(item)" @click.stop>添加到画布</div> -->
            <!-- <div
              v-if="UserMsg.payForMaterial != 1 && item.payType==1||item.payType==2||item.payType==3"
              class="price-style"
            >{{'￥'+ item.price}}</div>
            <div
              v-if="item.payType==4"
              class="vip-logo"
            ></div> -->
            <payType-subscript
              :item="item"
              style="right: 4px; bottom: 4px"
            ></payType-subscript>
            <div class="favorites-bg" @click="favoriteItem(item)" @click.stop>
              <div
                class="favorites-state"
                :class="[
                  item && item.favorites ? 'already-favorites' : 'no-favorites',
                ]"
              ></div>
            </div>
          </div>
          <!-- <img :src="$handleAssetsUrl(item.thumbnailUrl)" /> -->
        </li>
      </ul>
      <div class="loading">
        <Loading
          :loading="loadingStatus == 1"
          v-show="loadingStatus == 1"
        ></Loading>
        <div v-show="loadingStatus == 2">没有更多内容了哦</div>
      </div>
    </div>

    <isEmptyResult
      v-if="loadingStatus == 2 && contentList.length == 0"
    ></isEmptyResult>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import searchBar from "../searchBar";
import styleMenu from "../dropDownMenu";
import filterMenu from "../filterMenu";
import isEmptyResult from "../isEmptyResult";
import baseContent from "./baseContent.vue";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";
import Loading from "@/components/emodal/templateLib/loading";

export default {
  name: "textContent",
  mixins: [baseContent],
  data () {
    return {
      type: 16,
      //条件筛选
      fileType: null,

      fileTypeFlags: [
        { name: "全部", value: "" },
        { name: "文字贴纸", value: "&fileType=11" },
        // { name: "动态", value: "&fileType=15" },
        { name: "文字组合", value: "&fileType=30" },
      ],
      priceFlags: [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        // { name: "付费", value: "&payType=1,2,3" },
        { name: "会员专属", value: "&payType=4" },
        { name: "企业会员专属", value: "&payType=6" },
      ],
    };
  },

  components: {
    searchBar,
    styleMenu,
    filterMenu,
    isEmptyResult,
    PayTypeSubscript,
    Loading,
  },
  methods: {
    getContentList: function (isRefresh) {
      this.loadingStatus = 1;
      let url =
        "/api/common/material?type=16&fPage=24&sOfPage=24&pIndex=" +
        this.pageIndex;
      if (this.category && this.category.id != null) {
        url += "&category=" + this.category.id;
      }
      // if (this.currentStyle) {
      //   url += "&style=" + this.currentStyle.id;
      // }
      if (this.fileType) {
        url += this.fileType.value;
      }
      if (this.sort) {
        url += this.sort.value;
      }
      if (this.price) {
        url += this.price.value;
      }
      if (this.commerical) {
        url += this.commerical.value;
      }
      if (
        typeof this.keyWord != "undefined" &&
        this.keyWord != null &&
        this.keyWord != ""
      ) {
        url += "&keyword=" + this.keyWord;
      }
      this.setTrackingData(url);
      this.$http
        .get(url)
        .then((res) => {
          if (this.keyWord) {
            let order_methods = {
              "": "推荐",
              "&orderBy=2": "最新",
            };
            let choose_prices = {
              "": "全部",
              "&payType=0": "免费",
              "&payType=4": "会员专属",
              "&payType=1,2,3": "付费",
              "&payType=6": "企业会员专属"
            };
            sensors.track("classifySearchResult", {
              search_source: "编辑器素材弹窗",
              keyword: this.keyWord,
              has_result: !!(res.data.data && res.data.data.length),
              material_type: "文字",
              search_type: "素材搜索",
              search_result_num: res.data.data.length,
              keyword_type: this.trackingData.keyword_type || "手动输入",
              order_method: this.sort ? order_methods[this.sort.value] : "推荐",
              choose_price: this.price
                ? choose_prices[this.price.value]
                : "全部",
            });
          }
          //console.log("获取文字：" + JSON.stringify(res.data));
          //this.totalCount = res.data.total;
          if (isRefresh) {
            //查询时列表重新赋值
            this.contentList = res.data.data;
          } else {
            if (!this.contentList) {
              this.contentList = [];
            }
            for (var i = 0; i < res.data.data.length; i++) {
              this.contentList.push(res.data.data[i]);
            }
          }
          if (res.data.total <= this.contentList.length) {
            this.loadingStatus = 2;
          } else {
            this.loadingStatus = 0;
          }
        })
        .catch((res) => {
          //console.log("获取数据失败");
          this.loadingStatus = 0;
        });
    },

    addToCanvas: function (item) {
      this.$bus.emit('beforeAddToCanvas', { data: item, type: 'text' });
      this.trackSearchResultClick(item);
      //console.log(JSON.stringify(item));
      switch (item.fileType) {
        case 11:
          this.addTextImage(item);
          break;
        case 30:
          this.addTextGroup(item);
          break;
      }

      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    addTextGroup: function (item) {
      const runner = () => {
        return fetch(this.$handleAssetsUrl(item.url))
          .then((res) => res.json())
          .then((json) => {
            let groupData = {
              id: item.id + "," + uuid.generate(),
              fileType: item.fileType,
              resourceId: item.id,
              thumbnailUrl: item.thumbnailUrl,
              type: 16,
            };
            let sizeW = 1920;
            let sizeH = (1920 * 9) / 16;
            let arrX = [];
            let arrY = [];
            let minX = 0;
            let minY = 0;
            json.forEach((s) => {
              let { x, y, width, height } = s.outward;
              let sizeX = Math.max(0, x) + width;
              let sizeY = Math.max(0, y) + height;
              arrX.push(sizeX);
              arrY.push(sizeY);
              if (x < minX) {
                minX = x;
              }
              if (y < minY) {
                minY = y;
              }
            });
            let sizeX = Math.max.apply(null, arrX) - minX;
            let sizeY = Math.max.apply(null, arrY) - minY;
            json.forEach((s, i) => {
              s._scale = 1 / this.TOOL.scale;

              s.fileType -= 0;
              s.zIndex = this.TOOL.selectedScenes.sprites.length + i;
              s.outward.x = s.outward.x + sizeW / 2 - sizeX / 2;
              s.outward.y = s.outward.y + sizeH / 2 - sizeY / 2;

              let isNearTimeEnd = this.SelectScenes_Msg.duration / 1000 - this.SelectScenes_Msg.nowTime <= 0.5;
              if (isNearTimeEnd) {
                this.SelectScenes_Msg.nowTime = this.SelectScenes_Msg.duration / 1000 - 0.5;
              }

              if (s.enterEffect.type === "None") {
                s.startTime = this.SelectScenes_Msg.nowTime;
                s.enterEffect.duration = 0;
                s.stayEffect.duration =
                  this.SelectScenes_Msg.duration / 1000 - s.startTime;
              } else {
                s.startTime = this.SelectScenes_Msg.nowTime - 0.5;
                s.enterEffect.duration = 0.5;
                s.stayEffect.duration =
                  this.SelectScenes_Msg.duration / 1000 - s.startTime - 0.5;
              }

              s.exitEffect.type = "None";
              s.exitEffect.duration = 0;
              s.groupId = groupData;
            });
            return this.SelectScenes_Msg.toFromJson(json, 1, true).then(() => {
              let sprites = this.TOOL.selectedScenes.sprites;
              let arr = sprites.slice(-json.length);
              let maxEnter = 0;
              let arrS = [];
              let arrS2 = [];
              arr.forEach((sprite) => {
                if (sprite.effect.entranceAnim.end > maxEnter) {
                  maxEnter = sprite.effect.entranceAnim.end;
                }
                if (
                  !(sprite.effect.pathAnim && sprite.effect.pathAnim.target)
                ) {
                  arrS.push(sprite);
                }
                arrS2.push(sprite);
              });
              this.TOOL.selectSprite(arrS);
              eve("timeline_nowTime_change", null, {
                nowTime: maxEnter / 1000 + 0.5,
                noPlay: true,
              });
              return arrS2;
            });
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: "文字组合加载失败，请重试",
            });
          });
      };
      if (this.SpriteOperation === "swap") {
        let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
        this.TOOL.swapSprite(
          {
            sprite,
            typeForAdd: "group",
            optionForAdd: {
              callback: runner,
            },
          },
          true
        );
      } else {
        runner();
      }
    },
    addTextImage: function (item) {
      const isGif = (name) => /\.gif$/i.test(name);
      const gifOrImage = (name) => (isGif(name) ? "Gif" : "Image");
      if (this.SpriteOperation === "swap") {
        let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

        this.TOOL.swapSprite(
          {
            sprite,
            typeForAdd: gifOrImage(item.url),
            optionForAdd: {
              url: item.url,
              resourceId: item.id, // 资源id
              fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
            },
          },
          true
        );
      } else {
        this.TOOL.addSprite(
          gifOrImage(item.url),
          {
            url: item.url,
            resourceId: item.id,
            fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
            isLoop: false,
            effectCode: "FadeIn",
          },
          null,
          true
        );
      }
    },
    favoriteItem: function (item) {
      let postBody = {
        type: 16,
        id: item.id,
      };
      if (item.favorites) {
        postBody.isCancel = 1;
      }
      item.sprite = item;
      this.trackCollectContent({ ...item, collect_content: "文字" }, postBody);
      this.$http.post("/api/user/favorites", postBody).then((res) => {
        if (res.data.code == 200) {
          this.showLikesToast(postBody.isCancel ? 'unlikes' : 'likes');
          //请求的返回值中没有带收藏信息
          //所以这里做一个本地的伪处理
          if (item.favorites) {
            item.favorites = null;
            this.$bus.emit("favorites.toggle", item, false); //通知右侧列表
          } else {
            item.favorites = true;
            this.$bus.emit("favorites.toggle", item, true);
          }
        }
      });
    },
    handleScroll (e) {
      if (this.loadingStatus != 0) {
        return;
      }
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.contentcontainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.pageIndex++;
        this.getContentList();
      }
    },
  },
  watch: {},
  computed: {
    ...mapGetters([
      "StyleArrayMsg",
      "TOOL",
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "SpriteOperation",
      "WorksProjectId",
      "UserMsg",
    ]),
  },
  created () {
    this.fileType = this.fileTypeFlags[0];
    this.sort = this.sortFlags[0];
    this.price = this.priceFlags[0];
    this.commerical = this.commericalFlags[0];

    //this.setStyle(0);
    //this.refreshCategorys();
    //this.refreshContentList();
  },
  mounted () {
    //this.refreshCategorys();
  },
};
</script>

<style scoped lang="scss">
.rootContainer {
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
#top-bar-container {
  background-color: #fff;
  min-height: 50px;
  margin: 8px 40px 20px 40px;
  padding: 0;
  flex-shrink: 0;
}

.fixed-filter-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 20px;
  /* margin-top: 10px; */
}

.fixed-filter-container .fixedFilter {
  margin-left: 29px;
}

.fixed-filter-container /deep/ .list-container {
  margin-left: 10px;
}

.fixed-filter-container /deep/ .list li {
  padding: 0 10px;
}

.content-container {
  /* position: relative;
  height: 495px; */
  width: 100%;
  overflow-y: auto;
  flex-grow: 1;
}

.content-list {
  padding: 22px 0px 0px 39px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  /* overflow-y: auto; */
  /* height: 495px; */
  width: 100%;
  flex-grow: 1;
}
.loading {
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333333;
  //line-height: 110px;

  &>div{
    height:30px;
    line-height: 30px;
    align-self: start;
  }
}

.content-list li {
  width: 140px;
  height: 140px;
  background-color: #fff;
  border-radius: 6px;
  border: solid 1px #f0f0f8;
  box-sizing: border-box;
  margin-right: 25px;
  margin-bottom: 30px;
  overflow: hidden;

  transition: all 0.4s;
}

/* .content-list li:nth-child(6n) {
  margin-right: 0px;
} */

.content-list li:hover {
  transform: scale(1.14);
}

.content-list li:hover .addbtn {
  opacity: 1;
}

.content-list li:hover .price-style {
  opacity: 0;
}

.content-list li:hover .logo-container {
  opacity: 0;
}

.content-list li:hover .favorites-bg {
  display: block;
  animation: favorites-fadein 0.4s;
}

.addbtn {
  position: absolute;
  display: block;
  width: 88px;
  height: 28px;
  background-color: #5778fb;
  border-radius: 13px;
  left: 4px;
  bottom: 4px;

  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;

  opacity: 0;
  transition: all 0.4s;
}

.price-style {
  position: absolute;
  bottom: 4px;
  right: 4px;
  /* width: 72px; */
  height: 18px;
  padding: 0 6px;
  color: #ffffff;
  font-size: 12px;
  background-image: linear-gradient(108deg, #fa2dfc 0%, #325eff 100%);
  border-radius: 4px;
  text-align: center;

  transition: all 0.4s;
}

.bg {
  position: relative;
  width: 100%;
  height: 100%;
}

.static-cover {
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  width: auto;
  transform: translate(-50%, 0);
  object-fit: contain;
  background: #fff;
}

.logo-container {
  position: absolute;

  right: 0;
  display: flex;
  justify-content: flex-end;

  transition: all 0.4s;
}

.commerical-logo {
  width: 20px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/commerical.svg);
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 5px;
}

.vip-logo {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 64px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/vip-exclusive.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

@keyframes favorites-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.7;
  }
}

.favorites-bg {
  display: none;
  position: absolute;
  width: 24px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  right: 4px;
  top: 4px;

  opacity: 0.7;
  /* transition: all 0.4s; */
}

.favorites-bg:hover {
  opacity: 1;
}

.favorites-state {
  width: 12px;
  height: 12px;
  margin-top: 4px;
  margin-left: 6px;
}

.already-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/already-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}
.no-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/no-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

.style-layout {
  margin-left: 39px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/textContent.vue